module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.60202546.ttf";